export function updateRatingContainerVisibility({ bvReviewsCountDiv, showEmptyReviews }) {
  const reviewsCount = +bvReviewsCountDiv?.innerText?.replace(/[^0-9]/g, '')
  if (!reviewsCount && showEmptyReviews !== 'show-empty-pdp') {
    const ratingSummaryDiv = document.querySelector('div[data-bv-show="rating_summary"]')
    ratingSummaryDiv && (ratingSummaryDiv.style.display = 'none')
  }
}
